

import React, { useState, useEffect } from "react";
import { Card, Button, Dropdown, Menu, Modal, Spin, Collapse, Typography, message, Tabs, List, Form, Input } from "antd";

import { useNavigate } from "react-router-dom";
import courseService from "../../services/course.service"; // Service API
import authHeader from "../../services/auth-header"; // Auth header for Bearer Token
import CourseCreateForm from "./CourseCreateForm";
import AddSubjectForm from "./AddSubjectForm";
// import API_BASE from "../config/apiConfig";
import QuizManager from "./QuizManager";
import { Editor } from "@tinymce/tinymce-react";


import API_BASE from "../../config/apiConfig";
import Title from "antd/es/skeleton/Title";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import EvaluationManager from "./EvaluationManager";
import TrainingForm from "./TrainingForm";
import { FileTextOutlined, TrophyOutlined, FileAddOutlined, PaperClipOutlined, BookOutlined, EllipsisOutlined, MoreOutlined, DeleteOutlined, EditOutlined, EyeOutlined, PlusOutlined, ReadOutlined, DownOutlined, PlusCircleOutlined } from "@ant-design/icons";
import BadgeManager from "./BadgeManager";
import CertificateGenerator from "./CertificateGenerator";


const API_BASE_URL = `${API_BASE}/images/proxy`; // Crée une URL dynamique basée sur la configuration


const ModeratorCourses = () => {
    const [refresh, setRefresh] = useState(false);

    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [isAddingSubject, setIsAddingSubject] = useState(false);
    const imageCache = {}; // Cache des images pour éviter les boucles infinies
    const moderatorId = 1; // Remplacez par l'ID du modérateur connecté
    const navigate = useNavigate();
    const [selectedAttachmentFile, setSelectedAttachmentFile] = useState(null);
    const [attachments, setAttachments] = useState([]);
    const [loadingAttachments, setLoadingAttachments] = useState(false);
    const [resources, setResources] = useState([]);
    const [selectedSubjectId, setSelectedSubjectId] = useState(null);
    const [selectedContent, setSelectedContent] = useState('');

    const [isAttachmentsModalVisible, setIsAttachmentsModalVisible] = useState(false);
    const [isResourcesModalVisible, setIsResourcesModalVisible] = useState(false);
    const [attachmentsBySubject, setAttachmentsBySubject] = useState({});
    const [resourcesBySubject, setResourcesBySubject] = useState({});

    const [selectionMode, setSelectionMode] = useState("content");

    const [isAddingResource, setIsAddingResource] = useState(false);
    const [newResourceContent, setNewResourceContent] = useState('');
    const [isQuizModalVisible, setIsQuizModalVisible] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false); // Pour la modale QuizManager
    const [newQuizTitle, setNewQuizTitle] = useState("");         // Pour le champ du titre du quiz
    const [selectedQuiz, setSelectedQuiz] = useState(null);       // Pour forcer un reset ou édition future

    const fetchResources = async (courseId) => {
        try {
            const response = await courseService.getResourcesByCourse(courseId);
            setResources(response);
        } catch (error) {
            console.error("Erreur lors de la récupération des ressources :", error);
        }
    };

    const fetchAttachmentsBySubject = async (subjectId) => {
        try {
            const response = await courseService.getAttachmentsBySubject(subjectId);
            setAttachmentsBySubject(prev => ({
                ...prev,
                [subjectId]: response
            }));
        } catch (error) {
            console.error("Erreur lors de la récupération des pièces jointes par sujet:", error);
        }
    };


    const fetchResourcesBySubject = async (subjectId) => {
        try {
            const response = await courseService.getResourcesBySubject(subjectId);
            setResourcesBySubject(prev => ({
                ...prev,
                [subjectId]: response
            }));
        } catch (error) {
            console.error("Erreur lors de la récupération des ressources par sujet:", error);
        }
    };

    const handleAddResource = async (values) => {
        try {
            await courseService.addResourceToSubject(selectedSubject.id, {
                title: values.title,
                content: newResourceContent,
            });


            message.success("Ressource ajoutée avec succès !");
            // await fetchResources(selectedCourse.id); // 🛠️ ici, je passe selectedCourse.id
            await fetchResourcesBySubject(selectedSubject.id);
            setIsAddingResource(false);
        } catch (error) {
            console.error("Erreur lors de l'ajout de la ressource :", error);
            message.error("Erreur lors de l'ajout de la ressource.");
        }
    };



    const handleViewResource = (resource) => {
        const url = resource.content?.trim(); // On récupère le contenu
        if (url) {
            // 🔥 ouvrir dans un nouvel onglet
            window.open(url.startsWith("http") ? url : `https://${url}`, "_blank");
        } else {
            message.error("Lien de ressource invalide.");
        }
    };


    const fetchAttachments = async (courseId) => {
        setLoadingAttachments(true);
        try {
            const response = await courseService.getAttachmentsByCourse(courseId);
            setAttachments(response);
        } catch (error) {
            console.error("Erreur lors du chargement des pièces jointes :", error);
        } finally {
            setLoadingAttachments(false);
        }
    };


    const handleUploadAttachment = async () => {
        if (!selectedAttachmentFile || !selectedCourse?.id) {
            message.error("Veuillez sélectionner un fichier et un cours.");
            return;
        }

        try {
            const response = await courseService.uploadAttachmentToCourse(selectedCourse.id, selectedAttachmentFile);
            message.success(`Fichier "${response.fileName}" uploadé avec succès !`);
            setSelectedAttachmentFile(null); // Reset le champ fichier après upload
            // Tu pourras aussi recharger la liste des attachments ici si besoin
        } catch (error) {
            message.error(error.message || "Erreur lors de l'upload.");
        }
    };

    useEffect(() => {
        const fetchCourses = async () => {
            try {
                const response = await courseService.getCoursesByModerator(1);

                const updatedCourses = await Promise.all(
                    response.map(async (course) => {
                        if (course.image && !imageCache[course.image]) {
                            const imageUrl = await fetchImage(course.image);
                            imageCache[course.image] = imageUrl; // Mise en cache de l'image
                            return { ...course, imageUrl };
                        } else {
                            return { ...course, imageUrl: imageCache[course.image] || "/default-image.png" };
                        }
                    })
                );
                setCourses(updatedCourses);
            } catch (error) {
                console.error("Erreur lors du chargement des cours :", error);
            } finally {
                setLoading(false);
            }
        };
        fetchCourses();
    }, [moderatorId]);


    const onDragEnd = (result) => {
        console.log("Drag & Drop event:", result);

        if (!result.destination) return; // Vérifie si l'élément a été déplacé

        const { source, destination, type } = result;

        if (type === "group") {
            console.log("Réorganisation des groupes");

            const items = Array.from(Object.entries(groupedSubjects));
            const [reorderedItem] = items.splice(source.index, 1);
            items.splice(destination.index, 0, reorderedItem);

            setGroupedSubjects(Object.fromEntries(items));
        } else if (type === "subject") {
            console.log("Réorganisation des sujets");

            const groupName = source.droppableId;
            const subjects = Array.from(groupedSubjects[groupName]);

            const [movedSubject] = subjects.splice(source.index, 1);
            subjects.splice(destination.index, 0, movedSubject);

            setGroupedSubjects((prev) => ({
                ...prev,
                [groupName]: subjects,
            }));
        }

        // 🚀 Forcer le re-rendu
        setRefresh((prev) => !prev);
    };




    const fetchImage = async (imageUrl) => {
        try {
            const response = await fetch(
                // `https://glistening-dedication-production.up.railway.app/api/images/proxy?url=${encodeURIComponent(imageUrl)}`,
                // `http://localhost:8080/api/images/proxy?url=${encodeURIComponent(imageUrl)}`,
                `${API_BASE_URL}?url=${encodeURIComponent(imageUrl)}`,

                {
                    headers: authHeader(),
                }
            );
            if (!response.ok) {
                throw new Error("Erreur lors de la récupération de l'image");
            }
            const blob = await response.blob();
            return URL.createObjectURL(blob);
        } catch (error) {
            console.error("Erreur lors de la récupération de l'image :", error);
            return "/default-image.png";
        }
    };

    const handleEditCourse = (course) => {
        setSelectedCourse(course);
        setIsEditing(true);
    };

    // const handleAddSubject = (course) => {
    //     setSelectedCourse(course);
    //     setIsAddingSubject(true);
    // };

    const handleAddSubject = async (course) => {
        setSelectedCourse(course);
        setSelectedSubject(null);
        await fetchResources(course.id); // 🔥 On charge les ressources dès qu'on ouvre
        setIsAddingSubject(true);
    };


    const [selectedCourseSubjects, setSelectedCourseSubjects] = useState([]);
    const [isSubjectsModalVisible, setIsSubjectsModalVisible] = useState(false);
    const [groupedSubjects, setGroupedSubjects] = useState({});

    useEffect(() => {
        console.log("Grouped Subjects Updated (Rendering):", groupedSubjects);
    }, [groupedSubjects]);




    const handleShowSubjects = async (course) => {
        setSelectedCourse(course);
        await fetchResources(course.id); // 🔥 Toujours charger les ressources du cours.

        console.log("Cours sélectionné :", course);

        try {
            const response = await courseService.getSubjectsByCourse(course.id);
            console.log("Sujets récupérés :", response);
            setSelectedCourseSubjects(response);

            // 🌟 Grouper correctement
            const grouped = response.reduce((acc, subject) => {
                if (!acc[subject.group_name]) acc[subject.group_name] = {};

                if (!acc[subject.group_name][subject.title]) {
                    acc[subject.group_name][subject.title] = [];
                }

                acc[subject.group_name][subject.title].push(subject);
                return acc;
            }, {});

            setGroupedSubjects(grouped);

            // ➡️  NOUVEAU : charger pour CHAQUE sujet ses attachments & ressources
            response.forEach(async (subject) => {
                await fetchAttachmentsBySubject(subject.id);
                await fetchResourcesBySubject(subject.id);
            });

            setIsSubjectsModalVisible(true);
        } catch (error) {
            console.error("Erreur lors de la récupération des sujets :", error);
        }
    };


    const [selectedSubject, setSelectedSubject] = useState(null);
    const [isEditingSubject, setIsEditingSubject] = useState(false);

    // const handleEditSubject = (subject) => {
    //     setSelectedSubject(subject);
    //     setIsEditingSubject(true);
    // };

    const handleEditSubject = (subject) => {
        console.log("Sujet sélectionné pour modification :", subject); // Debug
        console.log("Course ID sélectionné :", selectedCourse?.id); // Debug pour vérifier le cours

        setSelectedSubject({
            ...subject,
            courseId: subject.courseId || selectedCourse?.id, // Priorité à courseId sinon on prend celui du cours sélectionné
        });
        setIsEditingSubject(true);
    };

    const handleManageAttachments = (subject) => {
        setSelectedSubject(subject);
        setIsAttachmentsModalVisible(true);
        fetchAttachmentsBySubject(subject.id); // 🚀 nouvelle fonction
    };

    const handleManageResources = (subject) => {
        setSelectedSubject(subject);
        setIsResourcesModalVisible(true);
        fetchResourcesBySubject(subject.id);  // ✅ corrige bien ici
    };
    const handleSubjectSelection = (subject, mode = "content") => {
        setSelectedSubjectId(subject.id);
        setSelectionMode(mode);

        if (mode === "content") {
            setSelectedContent(subject.content || "<p>Aucun contenu disponible.</p>");
        } else if (mode === "attachments") {
            const attachments = attachmentsBySubject[subject.id] || [];
            const html = attachments.map(att => `
            <div style="margin-bottom: 10px;">
              <a href="${att.fileUrl}" target="_blank" style="color: #3f51b5; font-weight: bold;">
                📎 ${att.fileName}
              </a>
            </div>
          `).join('');
            setSelectedContent(html || "<p>Aucune pièce jointe disponible.</p>");
        } else if (mode === "resources") {
            const resources = resourcesBySubject[subject.id] || [];
            const html = resources.map(res => `
            <div style="margin-bottom: 10px;">
              <span style="color: #4caf50; font-weight: bold;">📚 ${res.title}</span>
              <div>${res.content}</div>
            </div>
          `).join('');
            setSelectedContent(html || "<p>Aucune ressource disponible.</p>");
        } else if (mode === "compris") {
            setSelectedContent("<p>✅ Compris !</p>");
        }
    };



    const handleShowAttachments = (subject) => {
        setSelectedSubjectId(subject.id);
        const attachments = attachmentsBySubject[subject.id] || [];

        const html = attachments.map(att => `
            <div style="margin-bottom: 10px;">
                <a href="${att.fileUrl}" target="_blank" style="color: #3f51b5; font-weight: bold;">
                    📎 ${att.fileName}
                </a>
            </div>
        `).join('');

        setSelectedContent(html || "<p>Aucune pièce jointe disponible.</p>");
    };

    const handleShowResources = (subject) => {
        setSelectedSubjectId(subject.id);
        const resources = resourcesBySubject[subject.id] || [];

        const html = resources.map(res => `
            <div style="margin-bottom: 10px;">
                <span style="color: #4caf50; font-weight: bold;">📚 ${res.title}</span>
                <div>${res.content}</div>
            </div>
        `).join('');

        setSelectedContent(html || "<p>Aucune ressource disponible.</p>");
    };


    const handleDeleteSubject = (subjectId) => {
        Modal.confirm({
            title: "Confirmation",
            content: "Êtes-vous sûr de vouloir supprimer ce sujet ? Cette action est irréversible.",
            okText: "Oui, supprimer",
            okType: "danger",
            cancelText: "Annuler",
            onOk: async () => {
                setLoading(true); // Affichage du Spin pendant la suppression
                try {
                    await courseService.deleteSubject(subjectId);
                    message.success("Sujet supprimé avec succès.");

                    // Actualisation de la liste des sujets
                    const updatedSubjects = selectedCourseSubjects.filter(subject => subject.id !== subjectId);
                    setSelectedCourseSubjects(updatedSubjects);

                    // Si aucun sujet ne reste, fermer le Modal
                    if (updatedSubjects.length === 0) {
                        setTimeout(() => {
                            setIsSubjectsModalVisible(false);
                        }, 800); // Fermeture du Modal après 800 ms
                    } else {
                        // Si des sujets restent, fermer le Modal après le message de succès
                        setTimeout(() => {
                            setIsSubjectsModalVisible(false);
                        }, 800); // Fermeture du Modal après 800 ms
                    }
                } catch (error) {
                    message.error("Erreur lors de la suppression du sujet.");
                } finally {
                    setLoading(false); // Cacher le Spin après l'opération
                }
            }
        });
    };





    if (loading) {
        return <Spin size="large" style={{ display: "block", margin: "auto" }} />;
    }

    const handleDeleteCourse = (courseId) => {
        Modal.confirm({
            title: "Confirmation",
            content: "Êtes-vous sûr de vouloir supprimer ce cours ? Cette action est irréversible.",
            okText: "Oui, supprimer",
            okType: "danger",
            cancelText: "Annuler",
            onOk: async () => {
                setLoading(true);
                try {
                    await courseService.deleteCourse(courseId);
                    message.success("Cours supprimé avec succès !");
                    setCourses((prevCourses) => prevCourses.filter(course => course.id !== courseId));
                } catch (error) {
                    message.error("Erreur lors de la suppression du cours.");
                } finally {
                    setLoading(false);
                }
            }
        });
    };

    const getCourseActions = (course) => (
        <Menu>
            <Menu.Item key="1" icon={<EditOutlined />} onClick={() => handleEditCourse(course)}>
                Modifier le cours
            </Menu.Item>
            <Menu.Item key="2" icon={<PlusOutlined />} onClick={() => navigate(`/mod/course/${course.id}/subjects`)}>
                Ajouter un élément
            </Menu.Item>
            <Menu.Item key="3" icon={<EyeOutlined />} onClick={() => navigate(`/mod/course/${course.id}/view`)}>
                Voir les sujets
            </Menu.Item>
            <Menu.Item key="4" icon={<DeleteOutlined />} onClick={() => handleDeleteCourse(course.id)} danger>
                Supprimer le cours
            </Menu.Item>
        </Menu>
    );

    if (loading) {
        return <Spin size="large" className="flex justify-center items-center h-screen" />;
    }
    const { Title, Text } = Typography;
    const { TabPane } = Tabs;

    return (
        <div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                }}
            >
                <h2 style={{ margin: "0", fontSize: "24px", fontWeight: "bold" }}>Mes Cours</h2>
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => navigate("/mod/create-course")}
                    style={{ backgroundColor: "#4A90E2", borderColor: "#4A90E2" }}
                >
                    Ajouter un cours
                </Button>
            </div>

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
                    gap: "20px",
                }}
            >
                {courses.map((course) => (
                    <Card
                        key={course.id}
                        hoverable
                        cover={
                            <img
                                alt={course.title}
                                src={course.imageUrl || "/default-image.png"}
                                style={{
                                    height: "180px",
                                    objectFit: "cover",
                                    borderRadius: "8px 8px 0 0",
                                }}
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = "/default-image.png"; // Image par défaut
                                }}
                            />
                        }
                        style={{
                            borderRadius: "8px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            overflow: "hidden",
                            position: "relative",
                        }}
                    >
                        <div style={{ padding: "15px" }}>
                            {/* <h3 style={{ fontSize: "18px", fontWeight: "bold", margin: "0 0 10px 0" }}>
                                {course.title}
                            </h3> */}
                            <Title level={2} style={{ marginBottom: 10, fontSize: "13px" }}>
                                {course.title}
                            </Title>
                            <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
                                <strong>Leçons :</strong> {course.lessons || "0"} | <strong>Prix :</strong> {course.latest_price || "0"}
                            </p>
                            <p
                                style={{
                                    color: course.price ? "#1890ff" : "#52c41a",
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    margin: "0",
                                }}
                            >
                                {course.price || "Gratuit"}
                            </p>


                            <Dropdown
                                overlay={
                                    <Menu>
                                        <Menu.Item key="1" icon={<EditOutlined />} onClick={() => handleEditCourse(course)}>
                                            Modifier le cours
                                        </Menu.Item>
                                        <Menu.Item key="2" icon={<PlusOutlined />} onClick={() => handleAddSubject(course)}>
                                            Ajouter un élément
                                        </Menu.Item>
                                        <Menu.Item key="3" icon={<EyeOutlined />} onClick={() => handleShowSubjects(course)}>
                                            Voir les sujets
                                        </Menu.Item>
                                        <Menu.Item key="4" icon={<DeleteOutlined />} onClick={() => handleDeleteCourse(course.id)} danger>
                                            Supprimer le cours
                                        </Menu.Item>
                                    </Menu>
                                }
                                trigger={["click"]}
                            >
                                <Button type="primary" block>
                                    Actions <DownOutlined />
                                </Button>
                            </Dropdown>




                        </div>
                    </Card>
                ))}
            </div>
            <Modal
                visible={isEditingSubject}
                title="Modifier le sujet"
                footer={null}
                width="50%"
                onCancel={() => setIsEditingSubject(false)}
            >
                <AddSubjectForm
                    subject={selectedSubject}
                    onClose={() => setIsEditingSubject(false)}
                />
            </Modal>




            <Modal
                visible={isEditing}
                title={`Modifier le cours : ${selectedCourse?.title}`}
                footer={null}
                width="80%"
                style={{ top: 20 }}
                onCancel={() => setIsEditing(false)}
            >
                <CourseCreateForm
                    btnText="Modifier le cours"
                    initialData={selectedCourse} // Passe les données sélectionnées au formulaire
                    onClose={() => {
                        setIsEditing(false);
                        // refreshCourses();
                    }}
                />
            </Modal>



            <Modal
                open={isAddingSubject}
                title={`Ajouter des éléments au cours : ${selectedCourse?.title}`}
                footer={null}
                width="90%"
                onCancel={() => setIsAddingSubject(false)}
                style={{ top: 20 }}
            >
                {/* <Tabs defaultActiveKey="1" tabPosition="top" type="line"> */}
                <Tabs defaultActiveKey="1" tabPosition="top" type="line" onChange={(activeKey) => {
                    if (activeKey === "3") {
                        fetchAttachments(selectedCourse?.id);
                    }
                }}>
                    <TabPane
                        tab={
                            <span>
                                <FileTextOutlined style={{ color: "#1890ff" }} /> Sujet
                            </span>
                        }
                        key="1"
                    >
                        <Card size="small" title={`Ajouter un sujet au cours : ${selectedCourse?.title}`}
                        >
                            <AddSubjectForm
                                key={selectedCourse?.id}
                                courseId={selectedCourse?.id}
                                subject={null}
                                onClose={() => setIsAddingSubject(false)}
                            />
                        </Card>

                    </TabPane>

                    <TabPane
                        tab={
                            <span>
                                <FileAddOutlined style={{ color: "#52c41a" }} /> Contrôle des connaissances
                            </span>
                        }
                        key="2"
                    >
                        {/* <p>Ici, tu pourras intégrer le composant `QuizManager` ou un autre formulaire d'évaluation.</p> */}

                        <p>Gérer les contrôles pour le cours ID : {selectedCourse?.id}</p>


                        <EvaluationManager courseId={selectedCourse?.id} showInPage={true} />


                    </TabPane>

                    <TabPane
                        tab={
                            <span>
                                <ReadOutlined style={{ color: "#1890ff" }} /> Entraînement
                            </span>
                        }
                        key="5"
                    >
                        <TrainingForm courseId={selectedCourse?.id} />
                    </TabPane>
                    {/* *** gestion des badges *** */}
                    <TabPane
                        tab={
                            <span>
                                <TrophyOutlined style={{ color: "#fa541c" }} /> Badge
                            </span>
                        }
                        key="6"
                    >
                        <BadgeManager courseId={selectedCourse?.id} />
                    </TabPane>
                    {/* Gestion des certificats  */}
                    <TabPane
                        tab={
                            <span>
                                <TrophyOutlined style={{ color: "#fa541c" }} /> certificats
                            </span>
                        }
                        key="7"
                    >
                        {/* <BadgeManager courseId={selectedCourse?.id} /> */}
                        <CertificateGenerator
                            studentName="Ahmed El Mansouri"
                            courseTitle="Développement React avancé"
                        />

                    </TabPane>
                </Tabs>
            </Modal>


            <Modal
                visible={isEditingSubject}
                title={`Modifier le sujet : ${selectedSubject?.title}`}
                footer={null}
                width="50%"
                onCancel={() => setIsEditingSubject(false)}
            >
                {selectedSubject && (
                    <AddSubjectForm
                        subject={selectedSubject}  // On passe bien le sujet ici
                        onClose={() => setIsEditingSubject(false)}
                    />
                )}
            </Modal>


            <Modal
                open={isSubjectsModalVisible}
                title={`Liste des sujets : Cours numéro ${selectedCourse?.id || 'Non défini'}`}
                footer={null}
                width="60%"
                onCancel={() => setIsSubjectsModalVisible(false)}
            >
                {loading ? (
                    <Spin size="large" style={{ display: "block", margin: "auto" }} />
                ) : (
                    Object.keys(groupedSubjects).length > 0 ? (
                        <Collapse accordion>
                            {Object.entries(groupedSubjects).map(([groupName, subjects]) => (
                                <Collapse.Panel header={<b>{groupName}</b>} key={groupName}>
                                    <Collapse accordion>


                                        {Object.entries(subjects).map(([subjectTitle, subSubjects], subjectIndex) => (
                                            <Collapse.Panel header={<span style={{ fontWeight: "bold", color: "#1890ff" }}>{subjectTitle}</span>} key={subjectTitle}>
                                                <ul style={{ listStyleType: "none", padding: 0 }}>
                                                    {subSubjects.map((subject, subIndex) => {

                                                        const subNumber = `${subjectIndex + 1}.${subIndex + 1}`;
                                                        const attachments = attachmentsBySubject[subject.id] || [];
                                                        const resources = resourcesBySubject[subject.id] || [];

                                                        return (
                                                            <div key={subject.id} style={{ marginBottom: "10px" }}>
                                                                <li
                                                                    onClick={() => handleSubjectSelection(subject)}
                                                                    style={{ fontWeight: "bold", cursor: "pointer" }}
                                                                >
                                                                    {subNumber}. {subject.subTitle || subject.title}
                                                                </li>



                                                                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginLeft: '20px', marginTop: '10px' }}>
                                                                    <Button
                                                                        icon={<EditOutlined />}
                                                                        style={{
                                                                            minWidth: '140px',
                                                                            backgroundColor: '#1890ff',
                                                                            color: 'white',
                                                                            borderColor: '#1890ff',
                                                                            borderRadius: '6px'
                                                                        }}
                                                                        onClick={() => handleEditSubject(subject)}
                                                                    >
                                                                        Modifier
                                                                    </Button>

                                                                    <Button
                                                                        icon={<DeleteOutlined />}
                                                                        style={{
                                                                            minWidth: '140px',
                                                                            backgroundColor: '#ff4d4f',
                                                                            color: 'white',
                                                                            borderColor: '#ff4d4f',
                                                                            borderRadius: '6px'
                                                                        }}
                                                                        onClick={() => handleDeleteSubject(subject.id)}
                                                                    >
                                                                        Supprimer
                                                                    </Button>

                                                                    <Button
                                                                        icon={<PaperClipOutlined />}
                                                                        style={{
                                                                            minWidth: '140px',
                                                                            backgroundColor: '#fa8c16',
                                                                            color: 'white',
                                                                            borderColor: '#fa8c16',
                                                                            borderRadius: '6px'
                                                                        }}
                                                                        onClick={() => handleManageAttachments(subject)}
                                                                    >
                                                                        Pièces jointes ({attachments.length})
                                                                    </Button>

                                                                    <Button
                                                                        icon={<BookOutlined />}
                                                                        style={{
                                                                            minWidth: '140px',
                                                                            backgroundColor: '#722ed1',
                                                                            color: 'white',
                                                                            borderColor: '#722ed1',
                                                                            borderRadius: '6px'
                                                                        }}
                                                                        onClick={() => handleManageResources(subject)}
                                                                    >
                                                                        Ressources ({resources.length})
                                                                    </Button>



                                                                    <Button
                                                                        type="primary"
                                                                        onClick={() => {
                                                                            setSelectedSubject(subject); // ⬅️ CRUCIAL !
                                                                            setIsModalVisible(true);
                                                                            setNewQuizTitle("");
                                                                            setSelectedQuiz(null);
                                                                        }}
                                                                        icon={<EditOutlined />}
                                                                        style={{
                                                                            backgroundColor: "#52c41a",
                                                                            borderColor: "#52c41a",
                                                                            color: "white"
                                                                        }}
                                                                    >
                                                                        Gérer les Quizzes
                                                                    </Button>



                                                                </div>




                                                            </div>
                                                        );
                                                    })}


                                                </ul>
                                            </Collapse.Panel>
                                        ))}


                                    </Collapse>
                                </Collapse.Panel>
                            ))}
                        </Collapse>
                    ) : (
                        <p>Aucun sujet disponible pour ce cours.</p>
                    )
                )}
            </Modal>


            <Modal
                open={isAttachmentsModalVisible}
                title={`Pièces jointes pour : ${selectedSubject?.title || "Sujet inconnu"}`}
                footer={null}
                onCancel={() => setIsAttachmentsModalVisible(false)}
                width="60%"
            >
                {loadingAttachments ? (
                    <Spin size="large" style={{ display: "block", margin: "auto" }} />
                ) : (
                    <>
                        {/* 🔥 Affichage des pièces déjà existantes sous forme de cartes */}
                        {(attachmentsBySubject[selectedSubject?.id] || []).length > 0 ? (
                            <div
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
                                    gap: "15px",
                                    marginBottom: "20px",
                                }}
                            >
                                {(attachmentsBySubject[selectedSubject?.id] || []).map((item) => (
                                    <Card
                                        key={item.id}
                                        title={item.fileName}
                                        extra={
                                            <Button
                                                type="link"
                                                href={item.fileUrl}
                                                target="_blank"
                                                icon={<EyeOutlined />}
                                            >
                                                Voir
                                            </Button>
                                        }
                                    >
                                        <p><PaperClipOutlined /> {item.fileName}</p>
                                    </Card>
                                ))}
                            </div>
                        ) : (
                            <p style={{ textAlign: "center", marginBottom: "20px" }}>
                                Aucune pièce jointe trouvée.
                            </p>
                        )}


                        {/* 🔥 Uploader une nouvelle pièce jointe */}
                        <div style={{ textAlign: "center", marginTop: 20 }}>
                            <input
                                type="file"
                                onChange={(e) => setSelectedAttachmentFile(e.target.files[0])}
                                style={{ marginBottom: "10px" }}
                            />
                            <Button
                                type="primary"
                                onClick={async () => {
                                    if (!selectedAttachmentFile || !selectedSubject?.id) {
                                        message.error("Veuillez sélectionner un fichier et un sujet.");
                                        return;
                                    }
                                    try {
                                        await courseService.uploadAttachmentToSubject(
                                            selectedSubject.id,
                                            selectedAttachmentFile
                                        );
                                        message.success("Pièce jointe ajoutée avec succès !");
                                        setSelectedAttachmentFile(null);
                                        await fetchAttachmentsBySubject(selectedSubject.id); // 🔥 Refresh la liste directement
                                    } catch (error) {
                                        message.error(error.message || "Erreur lors de l'upload.");
                                    }
                                }}
                                disabled={!selectedAttachmentFile}
                            >
                                Uploader la pièce jointe
                            </Button>
                        </div>
                    </>
                )}
            </Modal>







            <Modal
                open={isResourcesModalVisible}
                title={`Ressources pour : ${selectedSubject?.title || "Sujet inconnu"}`}
                footer={null}
                onCancel={() => setIsResourcesModalVisible(false)}
                width="60%"
            >
                {/* <List
                    itemLayout="vertical"
                    dataSource={resources}
                     */}
                <List
                    itemLayout="vertical"
                    dataSource={resourcesBySubject[selectedSubject?.id] || []}
                    locale={{ emptyText: "Aucune ressource trouvée." }}
                    renderItem={(item) => (
                        <List.Item
                        // actions={[
                        //   <Button
                        //     type="link"
                        //     onClick={() => handleViewResource(item)}
                        //   >
                        //     Ouvrir
                        //   </Button>,
                        // ]}
                        >
                            <List.Item.Meta
                                title={item.title}
                                description={
                                    <div dangerouslySetInnerHTML={{ __html: item.content }} />
                                }
                            />
                        </List.Item>
                    )}
                />

                <div style={{ textAlign: "center", marginTop: 20 }}>
                    <Button
                        type="primary"
                        style={{ backgroundColor: "#722ed1", borderColor: "#722ed1", borderRadius: "8px" }}
                        onClick={() => setIsAddingResource(true)}
                    >
                        Ajouter une ressource
                    </Button>
                </div>





                {/* Modal interne pour ajouter une ressource */}
                <Modal
                    open={isAddingResource}
                    title="Ajouter une ressource"
                    footer={null}
                    onCancel={() => setIsAddingResource(false)}
                >
                    <Form
                        onFinish={async (values) => {
                            try {
                                await courseService.addResourceToSubject(selectedSubject.id, {
                                    title: values.title,
                                    content: newResourceContent,
                                });
                                message.success("Ressource ajoutée !");
                                await fetchResourcesBySubject(selectedSubject.id);
                                setIsAddingResource(false);
                                setNewResourceContent("");
                            } catch (error) {
                                message.error("Erreur lors de l'ajout de la ressource.");
                            }
                        }}
                        layout="vertical"
                    >
                        <Form.Item
                            name="title"
                            label="Titre"
                            rules={[{ required: true, message: "Veuillez entrer un titre" }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            name="content"
                            label="Contenu"
                            rules={[{ required: true, message: "Veuillez entrer un contenu" }]}
                        >
                            <Editor
                                apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle" // Remplace par ta clé API si nécessaire
                                //   apiKey="votre-cle-tiny"
                                onEditorChange={(value) => setNewResourceContent(value)}
                                init={{
                                    height: 300,
                                    menubar: false,
                                    plugins: ["link", "lists", "preview", "code"],
                                    toolbar: "undo redo | formatselect | bold italic | alignleft aligncenter alignright | bullist numlist | link",
                                }}
                            />
                        </Form.Item>

                        <Button type="primary" htmlType="submit" block>
                            Ajouter
                        </Button>
                    </Form>




                </Modal>
            </Modal>

            <Modal
                open={isModalVisible}
                title="Gestion des qizzes : "
                footer={null}
                onCancel={() => setIsModalVisible(false)}
                width="60%"
            >
                <QuizManager
                    subjectId={selectedSubject?.id}
                    quiz={selectedQuiz}
                    onClose={() => {
                        setIsModalVisible(false);
                        setNewQuizTitle("");
                        setSelectedQuiz(null);
                    }}
                />
            </Modal>

        </div>
    );










};

export default ModeratorCourses;


